import {Component, ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';

import {AItCreerRgReponseParametres, AItRgMessage} from '../DonneesTraitements';
import {AmmonInteractRgServiceService} from '../ammon-interact-rg-service.service';
import {BoiteDialogueGeneriqueComponent, DonneesTreeViewItem, SimpleTreeViewComponent, BarreProgressionComponent, SimpleLibelleComponent, SimpleImageComponent} from '../../../../val-composants-lib/src/public-api';
import {BoiteDialogueRgSimpleComponent} from "../boite-dialogue-rg-simple/boite-dialogue-rg-simple.component";
import {BoiteDialogueRgDateComponent} from "../boite-dialogue-rg-date/boite-dialogue-rg-date.component";
import {ValApiResultat} from '../../../../../val-ammon-services/val-services-communs-lib/src/public-api';

//Composant boîte de dialogue log
@Component (
{
  selector: 'val-boite-dialogue-log',
  imports: 
  [
    NgClass,
    BoiteDialogueGeneriqueComponent,
    SimpleTreeViewComponent,
    BarreProgressionComponent,
    SimpleLibelleComponent,
    SimpleImageComponent,
    BoiteDialogueRgSimpleComponent,
    BoiteDialogueRgDateComponent
  ],
  templateUrl: './boite-dialogue-log.component.html',
  styleUrl: './boite-dialogue-log.component.scss'
})
export class BoiteDialogueLogComponent 
{
  //Création
  //  Paramètres
  //    ammonInteractRgService : Service Ammon Interact
  constructor (private ammonInteractRgService: AmmonInteractRgServiceService) 
  {
    this.identifiantSession = "";
    this.validerDesactiver = true;
    this.items = [];
    this.etendu = 0;
    this.position = 0;
    this.itemsOuverts = [];
    this.identifiantEnCours = 0;
    this.titre = "";
    this.bandeau = "";
    this.titreDialogueRg = "";
    this.boutonOkVisible = false;
    this.boutonAnnulerVisible = false;
    this.boutonAbandonnerVisible = false;
    this.boutonRecommencerVisible = false;
    this.boutonIgnorerVisible = false;
    this.boutonOuiVisible = false;
    this.boutonNonVisible = false;
    this.message = "";
    this.iconeVisible = false;
    this.icone = "";
    this.nombreErreur = 0;
    this.nombreAvertissement = 0;
  }

  //Boîte de dialogue log
  @ViewChild ("boiteDialogueLog")
  public boiteDialogueLog!: BoiteDialogueGeneriqueComponent<any>;

  //Boîte de dialogue RG simple
  @ViewChild ("boiteDialogueRgSimple")
  public boiteDialogueRgSimple!: BoiteDialogueRgSimpleComponent;

  //Boîte de dialogue RG date
  @ViewChild ("boiteDialogueRgDate")
  public boiteDialogueRgDate!: BoiteDialogueRgDateComponent;

  //Identifiant de la session
  public identifiantSession: string;

  //Indique si le bouton valider est désactivé
  public validerDesactiver: boolean;

  //Items
  public items: DonneesTreeViewItem[];

  //Etendu
  public etendu: number;

  //Position
  public position: number;

  //Identifiants des items ouverts
  public itemsOuverts: number[];

  //Identifiant en cours
  public identifiantEnCours: number;

  //Titre
  public titre: string;

  //Bandeau
  public bandeau: string;

  //Titre boîte de dialogue RG
  public titreDialogueRg: string;

  //Indique si le bouton OK est visible
  public boutonOkVisible: boolean;

  //Indique si le bouton annuler est visible
  public boutonAnnulerVisible: boolean;

  //Indique si le bouton abandonner est visible
  public boutonAbandonnerVisible: boolean;

  //Indique si le bouton recommencer est visible
  public boutonRecommencerVisible: boolean;

  //Indique si le bouton ignorer est visible
  public boutonIgnorerVisible: boolean;

  //Indique si le bouton oui est visible
  public boutonOuiVisible: boolean;

  //Indique si le bouton non est visible
  public boutonNonVisible: boolean;

  //Indique si l’icone est visible
  public iconeVisible: boolean;

  //Icone
  public icone: string;

  //Message
  public message: string;

  //Nombre d’erreur
  public nombreErreur: number;

  //Nombre d’avertissement
  public nombreAvertissement: number;

  //Dernier item ajouté
  private dernierItem?: DonneesTreeViewItem;

  //Indique si la récupération des RG message est arrêtée
  private arrete: boolean = false;

  //Fonction de retour
  private fonctionRetour!: () => void;

  //Exécute
  //  Paramètres
  //    identifiantSession : Identifiant de la session
  public Executer (identifiantSession: string) : void 
  {
    this.identifiantSession = identifiantSession;
    this.validerDesactiver = true;
    this.items = [];
    this.itemsOuverts = [];
    this.identifiantEnCours = 0;
    this.nombreErreur = 0;
    this.nombreAvertissement = 0;
    this.arrete = false;

    this.RecupererRgMessage ();
  }

  //Arrête la récupération des RG message
  //  À appeler quand le traitement s’est terminé sans ouvrir de journal (refus avant toute action) :
  //  sans message STOP, la récupération ne s’arrêterait jamais.
  public Arreter () : void
  {
    this.arrete = true;
    this.validerDesactiver = false;
  }

  //Indique si la boîte de dialogue log est ouverte
  //  Retourne
  //    Vrai si le traitement a ouvert un journal
  public Ouverte () : boolean
  {
    return this.boiteDialogueLog.Ouverte ();
  }

  //Récupère les RG message
  private async RecupererRgMessage () : Promise<void>
  {
    let valApiResultat: ValApiResultat<AItRgMessage[]>;
    let continuer: boolean;

    if (this.arrete)
      return;

    try
    {
      valApiResultat = await this.ammonInteractRgService.RetournerRgMessages (this.identifiantSession);

      if (valApiResultat.status === "success")
      {
        continuer = true;

        if (valApiResultat.resultat!.length > 0)
        {
          for (const aitRgMessage of valApiResultat.resultat!)
          {
            if (aitRgMessage.typeMessage === 0)
              continuer = this.TraiterMessageLog (aitRgMessage);
            else
            {
              await this.TraiterMessageDialogueLog (aitRgMessage);
              continuer = true;
            }
          }
        }
        
        if (continuer)
        {
          await new Promise (retour => setTimeout (retour, 100));
          await this.RecupererRgMessage ();
        }
        else
          this.validerDesactiver = false;
      }
    }
    catch (erreur)
    {
      this.validerDesactiver = false;
    }
  }

  //Traite un RG message
  //  Paramètres
  //    aitRgMessage : RG message
  //  Retourne
  //    Vrai si la récupération des RG message doit continuer
  private TraiterMessageLog (aitRgMessage: AItRgMessage) : boolean 
  {
    let continuer: boolean;

    continuer = aitRgMessage.donneesMessage.type !== "STOP";

    if (continuer)
    {
      switch (aitRgMessage.donneesMessage.type)
      {
        case "INIT"        : this.OuvrirBoiteDialogueLog (aitRgMessage);           break;
        case "AJOUT"       : this.AjouterMessage (aitRgMessage);                   break;
        case "AJOUTDETAIL" : this.AjouterMessageDetail (aitRgMessage);             break;
        case "POSITION"    : this.position = aitRgMessage.donneesMessage.position; break;
      }
    }

    return continuer;
  }

  //Ouvre la boite de dîalogue log
  //  Paramètres
  //    aitRgMessage : RG message
  private OuvrirBoiteDialogueLog (aitRgMessage: AItRgMessage) : void 
  {
    this.titre = aitRgMessage.donneesMessage.titre;
    this.bandeau = aitRgMessage.donneesMessage.bandeau;
    this.etendu = aitRgMessage.donneesMessage.range > 0 ? aitRgMessage.donneesMessage.range : 0;
    this.position = 0;
    this.boiteDialogueLog.Ouvrir ();
  }

  //Ajoute un message
  //  Paramètres
  //    aitRgMessage : RG message
  private AjouterMessage (aitRgMessage: AItRgMessage) : void 
  {
    this.identifiantEnCours++;

    this.dernierItem = new DonneesTreeViewItem ();
    this.dernierItem.identifiant = this.identifiantEnCours;
    this.dernierItem.texte = aitRgMessage.donneesMessage.message;
    this.dernierItem.niveau = aitRgMessage.donneesMessage.niveau;

    if (this.dernierItem.niveau === 0)
      this.nombreErreur++;

    if (this.dernierItem.niveau === 5)
      this.nombreAvertissement++;

    this.items = this.items.concat ([this.dernierItem]);
  }

  //Ajoute un message détail
  //  Paramètres
  //    aitRgMessage : RG message
  private AjouterMessageDetail (aitRgMessage: AItRgMessage) : void 
  {
    let itemDetail: DonneesTreeViewItem;

    this.identifiantEnCours++;

    itemDetail = new DonneesTreeViewItem ();
    itemDetail.identifiant = this.identifiantEnCours;
    itemDetail.texte = aitRgMessage.donneesMessage.message;
    itemDetail.niveau = aitRgMessage.donneesMessage.niveau;

    if (itemDetail.niveau === 0)
      this.nombreErreur++;

    if (itemDetail.niveau === 5)
      this.nombreAvertissement++;

    if (this.dernierItem!.items)
    {
      this.dernierItem!.items.push (itemDetail);
    }
    else
      this.dernierItem!.items = [itemDetail];

    this.items = this.items.concat ([]);

    this.itemsOuverts.push (this.dernierItem!.identifiant);
    this.itemsOuverts = this.itemsOuverts.concat ([]);
  }

  //Attend la fermeture de la boîte de dialogue log
  public async AttendreFermeture () : Promise<void> 
  {
    let operation: Promise<void>;

    operation = new Promise<void> ((fonctionRetour) =>
    {
      this.fonctionRetour = fonctionRetour;
    });

    return operation;
  }

  //Ferme la boîte de dialogue log
  public Fermer () : void 
  {
    this.boiteDialogueLog.Fermer ();
    this.fonctionRetour ();
  }

  //Traite les message de la boîte de dialogue log
  //  Paramètres
  //    aitRgMessage : Données du message
  private async TraiterMessageDialogueLog (aitRgMessage: AItRgMessage) : Promise<void> 
  {
    switch (aitRgMessage.typeMessage)
    {
      case 1 : await this.OuvrirDialogueSimple (aitRgMessage); break;
    }
  }

  //Ouvre la boîte de dialogue simple
  //  Paramètres
  //    aitRgMessage : Données du message
  private async OuvrirDialogueSimple (aitRgMessage: AItRgMessage) : Promise<void> 
  {
    let aitCreerRgReponseParametres: AItCreerRgReponseParametres;
    
    aitCreerRgReponseParametres = new AItCreerRgReponseParametres ();
    aitCreerRgReponseParametres.identifiantSession = this.identifiantSession;
    aitCreerRgReponseParametres.typeMessage = 101;

    this.AfficherCacherBoutonsDialogueRg (aitRgMessage.donneesMessage.boutons);
    this.DefinirIconeDialogue (aitRgMessage.donneesMessage.icone);

    this.titreDialogueRg = aitRgMessage.donneesMessage.titre;
    this.message = aitRgMessage.donneesMessage.message;
    
    aitCreerRgReponseParametres.donneeReponse = await this.boiteDialogueRgSimple.Ouvrir ();

    try
    {
      await this.ammonInteractRgService.CreerRgReponse (aitCreerRgReponseParametres);
    }
    catch (erreur)
    {
    }
  }

  //Affiche / cache les boutons de la boîte de dialogue RG
  //  Paramètres
  //    boutons : Code de visibilité des boutons
  private AfficherCacherBoutonsDialogueRg (boutons: number) : void 
  {
    this.boutonOkVisible = boutons < 2;
    this.boutonAnnulerVisible = boutons === 1 || boutons === 3 || boutons === 5;
    this.boutonAbandonnerVisible = boutons === 2;
    this.boutonRecommencerVisible = boutons === 2 || boutons === 5;
    this.boutonIgnorerVisible = boutons === 2;
    this.boutonOuiVisible = boutons === 3 || boutons === 4;
    this.boutonNonVisible = boutons === 3 || boutons === 4;
  }

  //Définit l’icone de la boite de dialogue
  //  Paramètres
  //    icone : Code de l’icone
  private DefinirIconeDialogue (icone: number) : void 
  {
    this.iconeVisible = icone > 0;

    switch (icone)
    {
      case 16 : this.icone = "assets/erreur.png"; break;
      case 32 : this.icone = "assets/question.png"; break;
      case 48 : this.icone = "assets/exclamation.png"; break;
      case 64 : this.icone = "assets/information.png"; break;
    }
  }

  //private async OuvrirDialogueDate (aitRgMessage: AItRgMessage) : Promise<void> 
  //{
  //  let aitCreerRgReponseParametres: AItCreerRgReponseParametres;
    
  //  aitCreerRgReponseParametres = new AItCreerRgReponseParametres ();
  //  aitCreerRgReponseParametres.identifiantSession = this.identifiantSession;
  //  aitCreerRgReponseParametres.typeMessage = 101;

  //  this.titreDialogueDate = aitRgMessage.donneesMessage.titre;
  //  this.message = aitRgMessage.donneesMessage.message;
    
  //  aitCreerRgReponseParametres.donneeReponse = await this.boiteDialogueRgDate.Ouvrir ();

  //  try
  //  {
  //    //await this.ammonInteractRgService.CreerRgReponse (aitCreerRgReponseParametres);
  //  }
  //  catch (erreur)
  //  {
  //  }
  //}

}
